import type { PageNumber } from "@pdfking/renderer-api"
import { NullQ } from "@pdfking/structs"
export const PageNumbersToSignatureIndex = (
  blueline_page_numbers: PageNumber[][],
  page_numbers_to_sheet_cover_index: Record<PageNumber, number>
): Record<PageNumber, number> => {
  if (!blueline_page_numbers.length) return {}
  const result: Record<PageNumber, number> = {}
  let index = -1
  for (const line of blueline_page_numbers) {
    const page = line[line.length - 1]
    if (NullQ(page)) continue
    if (page in page_numbers_to_sheet_cover_index) index += 1
    result[page] = index
  }
  return result
}
